import $ from 'jquery';

export default class BlogPost {
  constructor(instance) {
    this.$el = $(instance.el);
    this.setFeaturedImage();
    this.artDirection();
    this.wrapAllNodes();

    $('.highlight').each((index, highlight) => {
      this.fixOverlappingElements($(highlight));
    });

    $(window).resize(() => {
      this.setFeaturedImage(true);
      if (window.innerWidth > 1020) {
        $('.highlight').each((index, highlight) => {
          this.fixOverlappingElements($(highlight));
        });
      }
    });
  }

  wrapAllNodes() {
    const { childNodes } = $('.rte', this.$el)[0];
    $.each(childNodes, (index, node) => {
      if ((node.nodeType === 3) && node.textContent.replace(/^\s+|\s+$/g, '')) {
        $(node).replaceWith(`<p>${node.textContent}</p>`);
      }
    });
  }

  fixOverlappingElements(highlight) {
    if ($('.post-meta').overlaps(highlight).length) {
      highlight.addClass('overlapping');
    }

    highlight.addClass('processed');
  }

  setFeaturedImage(resize) {
    const featuredImage = $('.featured-image', this.$el);

    if (featuredImage.length) {
      const parent = featuredImage.parent();
      const windowWidth = $(window).width();
      const contentWidth = $('.post-content', this.$el).width();

      if (resize) {
        featuredImage.css({
          width: windowWidth,
          marginLeft: -(windowWidth - contentWidth) / 2,
        });
        return;
      }

      featuredImage.detach().insertAfter('.page-title').css({
        width: windowWidth,
        marginLeft: -(windowWidth - contentWidth) / 2,
      }).addClass('processed');

      if (parent.is(':empty')) { parent.remove(); }
    }
  }

  artDirection() {
    const images = $('.post-content', this.$el);

    $(images[0]).one('rimg:load', (() => {
      images.each((index, value) => {
        const image = $(value);
        if (image.parent().hasClass('post-content')) {
          image.wrap('<div />');
        }

        const imageParent = image.parent();

        if (image.css('float') !== 'none') {
          const direction = image.css('float');
          imageParent.addClass(`highlight highlight-${direction}`);
          this.fixOverlappingElements(imageParent);
        }

        const imageWidth = image.width();
        const imageAlt = image.attr('alt');

        if (imageAlt && imageAlt.length && imageParent.not('img')) {
          const marginLeft = image.css('margin-left');
          const marginRight = image.css('margin-right');
          imageParent.append(`<div style='max-width: ${imageWidth}px; margin-left: ${marginLeft}; margin-right: ${marginRight};' class='photo-caption meta'>${imageAlt}</div>`);
        }
      });
    }));
  }
}
